import { useNavigate, useParams, type NavigateOptions } from "react-router-dom";

export const useNavigation = () => {
    const { org_uname } = useParams();

    const navigate = useNavigate();

    const navigateFromHome = (path: string, options?: NavigateOptions) => {
        navigate(`/o/${org_uname}/admin/${path}`, options);
    };

    return { navigateFromHome };
};
